module.exports = __webpack_public_path__ + "img/appmax.160d2359.png";